import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export default function Faq() {
  const [pages, setPages] = useState()

  function onLoadSuccess({ numPages }) {
    setPages(numPages)
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: 960, margin: 'auto', alignItems: 'baseline' }}>
        <h2>FAQ</h2>
        <a href='/FAQ.pdf' download='Martz FAQ.pdf'>Download</a>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Document {...{ onLoadSuccess, file: '/FAQ.pdf' }}>
          {
            Array.from(
              new Array(pages),
              (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                />
              ),
            )
          }
        </Document>
      </div>
    </div>
  )
}